"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccessorParams = void 0;
const common_1 = require("@finley-technologies/common");
const accruedLiabilitiesParams_1 = require("./accruedLiabilitiesParams");
const backupServicingCycleMetricsParams_1 = require("./backupServicingCycleMetricsParams");
const borrowingBaseMetricsParams_1 = require("./borrowingBaseMetricsParams");
const creditAgreementMetricsParams_1 = require("./creditAgreementMetricsParams");
const financialCovenantResultsParams_1 = require("./financialCovenantResultsParams");
const fundingRequestMetricsParams_1 = require("./fundingRequestMetricsParams");
const invoiceMetricsParams_1 = require("./invoiceMetricsParams");
const loanMetricsParams_1 = require("./loanMetricsParams");
const orgProvidedInputsParams_1 = require("./orgProvidedInputsParams");
const portfolioCovenantResultsParams_1 = require("./portfolioCovenantResultsParams");
const createAccessorParams = (params) => {
    const { dataAccessor } = params;
    const { method } = dataAccessor;
    switch (method) {
        case 'accruedLiabilities':
            return (0, accruedLiabilitiesParams_1.createAccruedLiabilitiesParams)({ dataAccessor }); // TODO: allow specific return types and move type checking to caller, context for issue: types are casted to any because accrued liabilities includes extra parameter that causes error when typescript attempts to determine return type (DataAccessor.Accessor is union type without specific parameter to distinguish accessor params)
        case 'backupServicingCycleMetrics':
            return (0, backupServicingCycleMetricsParams_1.createBackupServicingCycleMetricsParams)({ dataAccessor });
        case 'borrowingBaseMetrics':
            return (0, borrowingBaseMetricsParams_1.createBorrowingBaseMetricsParams)({ dataAccessor });
        case 'creditAgreementMetrics':
            return (0, creditAgreementMetricsParams_1.createCreditAgreementMetricsParams)({ dataAccessor });
        case 'fundingRequestMetrics':
            return (0, fundingRequestMetricsParams_1.createFundingRequestMetricsParams)({ dataAccessor });
        case 'invoiceMetrics':
            return (0, invoiceMetricsParams_1.createInvoiceMetricsParams)({ dataAccessor });
        case 'loanMetrics':
            return (0, loanMetricsParams_1.createLoanMetricsParams)({ dataAccessor });
        case 'portfolioCovenantResults':
            return (0, portfolioCovenantResultsParams_1.createPortfolioCovenantResultsParams)({ dataAccessor });
        case 'financialCovenantResults':
            return (0, financialCovenantResultsParams_1.createFinancialCovenantResultsParams)({ dataAccessor });
        case 'orgProvidedInputs':
            return (0, orgProvidedInputsParams_1.createOrgProvidedInputsParams)({ dataAccessor });
        default:
            return (0, common_1.finleyAssertUnreachable)(method);
    }
};
exports.createAccessorParams = createAccessorParams;
//# sourceMappingURL=index.js.map